import { render, staticRenderFns } from "./lcgl.vue?vue&type=template&id=fd30b708"
import script from "./lcgl.vue?vue&type=script&lang=js"
export * from "./lcgl.vue?vue&type=script&lang=js"
import style0 from "./lcgl.vue?vue&type=style&index=0&id=fd30b708&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports